import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import Header from '../components/Header/Header';
import LoginButton from '../components/Header/LoginButton';
import BlogComment from '../components/Post/Comments/BlogComment';
import { getUser } from '../helpers/token';
import withApollo from '../lib/withApollo';

const PublishCommentPage = () => {
  const router = useRouter();

  const [user, setUser] = useState(null);

  useEffect(() => {
    setUser(getUser());
  }, []);

  if (user === null) return <Header />;
  if (user === undefined)
    // TODO: Guest commenting system with captcha + email confirmation
    return (
      <>
        <Header />
        <LoginButton open hideButtons text=" to publish your comment" />
      </>
    );

  return (
    <>
      <Header />
      <div className="pt-5">
        <BlogComment query={router.query} user={user} />
      </div>
    </>
  );
};

export default withApollo(PublishCommentPage);
